import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const SetProfilePhotoApi = {
  // Makes one of the user's own gallery photos their profile photo.
  // Resolves to { status, data: { profile_pic, profile_complete } | { message } }.
  fromGallery: async (photoId) => {
    try {
      const response = await axiosInstance.post(Configs.setProfilePhotoFromGalleryEp, {
        photo_id: photoId,
      });
      return response.data;
    } catch (error) {
      const body = error?.response?.data;
      return body?.status ? body : { status: "fail", data: { message: "network_error" } };
    }
  },
};

export default SetProfilePhotoApi;
